import React from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';
import { Heading } from '../../typography';

export type ActionPriceSectionProps = {
  priceText: string;
};

const StyledActionPriceSection = styled.div`
  display: flex;
  flex-flow: column wrap;
  max-height: 100px;
  flex-grow: 1;

  ${breakpoint('sm')`
    max-height: 80px;
  `};
`;

const PriceHeading = styled(Heading)`
  ${breakpoint('xs', 'sm')`
    ${theme.typography.headings[4]['sm-lg']};
  `}
`;

export const ActionPriceSection: React.FC<ActionPriceSectionProps> = ({
  priceText,
}) => {
  return (
    <StyledActionPriceSection>
      <PriceHeading size={3}>{priceText}</PriceHeading>
    </StyledActionPriceSection>
  );
};
